import React from 'react';

import { colors } from 'global/colors';
import { xpLevelImages } from './XPLevelImages';
import { LevelImage, ExperienceBar, XPLevelBarText } from './styles';
import { SkillContainer, SkillHeader, Circle } from 'pages/ProfilePage/styles';

const xpImages = require.context('assets/xp');

export default function XPLevel({ width, level, xpPercent, xpInThisLevel, xpForLevel, totalXp, onClick }) {
  return (
    <>
      <SkillContainer width={width ? width : '100%'} onClick={onClick}>
        <SkillHeader>Level</SkillHeader>
        <Circle color={colors.fsCyan} margin="25px 0 0 0">
          {level}
        </Circle>
        {level && (
          <LevelImage src={xpImages(`./${xpLevelImages[level <= 30 ? level : 'default']?.image}`)}></LevelImage>
        )}
        <ExperienceBar experience={xpPercent}>
          <XPLevelBarText margin="0 0 0 10px">
            {xpInThisLevel} / {xpForLevel} XP ({isNaN(xpPercent) ? 0 : xpPercent}%)
          </XPLevelBarText>
          {level && (
            <XPLevelBarText margin="0 10px 0 0">{xpLevelImages[level <= 30 ? level : 'default']?.name}</XPLevelBarText>
          )}
          <XPLevelBarText margin="0 10px 0 0">Total: {totalXp} XP</XPLevelBarText>
        </ExperienceBar>
      </SkillContainer>
    </>
  );
}
